const defaultFormatter = (value) => value;

export const ChartTooltip = ({
    active,
    payload,
    label,
    formatter = defaultFormatter,
    title,
    valueLabel = "Значение",
}) => {
    const rows = (payload || []).filter((item) => item.value !== null && item.value !== undefined);

    if (!active || rows.length === 0) {
        return null;
    }

    const heading = title || label || rows[0]?.name;

    return (
        <div className="admin-chart-tooltip">
            {heading ? <p className="admin-chart-tooltip-title">{heading}</p> : null}
            <div className="admin-chart-tooltip-rows">
                {rows.map((item) => {
                    const color = item.color || item.fill || item.stroke || "var(--admin-money)";
                    const name = item.name === "value" ? valueLabel : item.name || valueLabel;

                    return (
                        <div className="admin-chart-tooltip-row" key={`${name}-${item.dataKey || item.value}`}>
                            <span style={{background: color}} />
                            <strong>{name}</strong>
                            <em>{formatter(item.value, name, item)}</em>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
